import React, { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { login } from './Services/Auth';
import getApi from './Services/index';
import LoadingOverlay from 'react-loading-overlay';
import jwtDecode from 'jwt-decode';
import './App.css'
import Login from './Login';

const AutoLogin = ({ history, location }) => {
    const [loading, setLoading] = useState(false);

    const verifyTokenExpiration = (expirationTime) => {
      const currentTime = Date.now() / 1000;
      return expirationTime >= currentTime
    }

    const authentication = useCallback(async () => {
      setLoading(true);
      const searchParams = new URLSearchParams(location.search);
      const token = searchParams.get('token');

      if (!token) {
        setLoading(false);
        history.push('/login');
        return;
      }

      let decoded_token;
      try {
        decoded_token = jwtDecode(token);
      } catch (error) {
        console.error('Erro ao decodificar token JWT:', error);
        setLoading(false);
        history.push('/login');
        return;
      }

      const { company_code, seller_code, order_id, exp } = decoded_token;

      if (!company_code || !seller_code || !order_id) {
        console.error('Credenciais incompletas no token.');
        setLoading(false);
        history.push('/login');
        return;
      }

      if (!verifyTokenExpiration(exp)) {
        console.error('Token expirado!');
        setLoading(false);
        history.push('/login');
        return;
      }

      try {
        const api = await getApi();
        const response = await api.post('/auth/auto-login/', {
          company_code: company_code, 
          seller_code: seller_code, 
          order_id: order_id 
        })
        const { status, data } = response

        if (status === 200) {
          login({ token: data.token });
          setLoading(false);          
          history.push(`/orders/${order_id}/detail`);
        } else {
          setLoading(false);
          history.push('/login');
        } 
      } catch (error) {
        console.error('Erro na autenticação:', error);
        setLoading(false);
        history.push('/login');
      }        
    }, [history, location]);
    
    useEffect(() => {
      authentication();
    }, [authentication]);

    return (
        <LoadingOverlay
          active={loading}
          spinner
          className={'loadingFullPage'}
          text="Autenticando automaticamente..."
        >
        <Login />
      </LoadingOverlay>
      
    );
};

export default withRouter(AutoLogin);